module.exports = __webpack_public_path__ + "img/setType.f1f03523.png";